@if (builtSpans) {
  @for (txt of builtSpans; track $index) {
    <span>{{ txt }}</span>
  }
}
